import React, { useEffect } from "react";
import { useAuth0 } from "utils/react-auth0-wrapper";
import queryString from "query-string";

/* purpose is to logout user so they must reverify before validating email change */
const EmailVerificationRedirect = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    // Segment's reset() is a real runtime method, but the global
    // Window["analytics"] type in types/globals.d.ts does not declare it —
    // cast at this boundary until that global type gains reset().
    (
      window.analytics as typeof window.analytics & { reset: () => void }
    ).reset();
    const verificationId = queryString.parse(
      window.location.search
    ).verificationId;

    logout({
      logoutParams: {
        returnTo:
          window.location.origin +
          "/verify-email?verificationId=" +
          // query-string types parsed values as string | string[] | null;
          // String() reproduces the original `+`-coercion behavior.
          String(verificationId),
      },
    });
  }, []);

  return <div></div>;
};

export default EmailVerificationRedirect;
